module.exports = __webpack_public_path__ + "static/tat-28-b5808d5711a3f5b321ab34336de1a97c.jpg";